import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { ThanhPhamModel } from '../thanh-pham-model/thanh-pham.model';
const API_ROOT_URL = environment.ApiRoot + '/hanghoa';
@Injectable()
export class ThanhPhamService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
			const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
			return this.http.get<any>(API_ROOT_URL + '/DM_Hanghoa_List', { 
				headers: httpHeaders,
				params: httpParams
			});
	}
	getThanhPhamById(itemId: any): Observable<any> {
		return this.http.get<any>(API_ROOT_URL + `/DM_HangHoa_Detail?Id_HH=${itemId}`);
	}
	deleteThanhPham(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DM_HangHoa_Delete?Id_HH=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	deleteThanhPhams(ids: any[] = []): Observable<any> {
		const url = API_ROOT_URL + '/DM_HangHoa_Multi_Delete';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QueryResultsModel>(url, ids, { headers: httpHeaders} );
	}
	createThanhPham(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<ThanhPhamModel>(API_ROOT_URL+'/DM_HangHoa_Insert', item, { headers: httpHeaders });
	}
	updateThanhPham(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<ThanhPhamModel>(API_ROOT_URL+'/DM_HangHoa_Update', item, { headers: httpHeaders });
	}
	updateThanhPhamDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<ThanhPhamModel>(API_ROOT_URL+'/DM_HangHoa_Update_Detail', item, { headers: httpHeaders });
	}
	uploadFileThanhPham(data): Observable<any> {
		const url = API_ROOT_URL + '/DM_HangHoa_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	importThanhPham(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<ThanhPhamModel>(API_ROOT_URL+'/DM_HangHoa_Import', item, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + `/DownLoadFileImportMau`;
	}
	listId_NhomHH(itemId: any) : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  API_ROOT_URL + `/DM_NhomHangHoa_List?idLoaiHH=${itemId}` ;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listDVT1() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_DVT_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listBoPhanKiemTra() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_PhongBan_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listListNCC() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_NCC_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listListKH() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_KhachHangCha_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}

	listDongSanPham() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_DongSanPham_List?idloaihh=4' ;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	downloadTCNPL(itemId: any): string {
		return API_ROOT_URL + `/DownLoadFileTieuChuanNPL?id=${itemId}`;
	}
}
